import { Component, OnInit } from '@angular/core';
@Component({ templateUrl: './content.component.html' })
export class ThirdPartyNotesSupportComponent implements OnInit {

  sourceList = [];

  version = '2020-08-28';

  ngOnInit(): void {
    this.loadCentiliSource();
    this.loadIonnex();
    this.load6969JP();
    this.loadPureTech();
    this.loadQatarOoredoo();
    this.loadUaEtisalat();
    this.loadUaDU();
    this.loadAbis();
    this.loadIonnexMT();
    this.loadQrSolutions();
  }

  private loadCentiliSource(){
      let sourceName = "Centili";
      let notesList = [];

      notesList.push("The api document URL: https://dev.centili.com/docs/payment-result-notification");
      notesList.push("Our work is to receive notification and import them to our system");
      notesList.push("Postback URL: http://pays2s.muslimgo.org/centili/dn");

      this.sourceList.push({"name":sourceName, "notes": notesList});
  }


  private loadIonnex(){
    let sourceName = "Ionnex";
    let notesList = [];

    notesList.push("Our work is to receive mo&dn notifications and import them to our system.");
    notesList.push("Update1: migrate to Ionnex_MT in order to do renewal by our side and control the schedule by us.");
    notesList.push("Update2: add this source to TxKeyword to broadcast content for Thailand keywords.");
    notesList.push("Notes: [[**Broadcast Setting**]] we only need to setup one keyword for all carrier, coz the broadcast api contains all operator per calling");
    notesList.push("Thailand Keyword Callback URL: [MO URL]: http://pays2s.intelligent-earnings.com/ionnex/th/mo [DN URL]: http://pays2s.intelligent-earnings.com/ionnex/th/dn");
    notesList.push("Malaysia Keyword Callback URL(Except Celcom carrier): [MO URL]: http://pays2s.intelligent-earnings.com/ionnex/my/mo [DN URL]: http://pays2s.intelligent-earnings.com/ionnex/my/dn");

    this.sourceList.push({"name":sourceName, "notes": notesList});
  }

  private load6969JP(){
    let sourceName = "6969JP";
    let notesList = [];

    notesList.push("We get all dn records by spider method day by day");
    notesList.push("We receive mo(success&failed) by callback url");
    notesList.push("Customer Event URL: http://pays2s.intelligent-earnings.com/6969jp/th/customer-event");
    notesList.push("Fail Registration URL: http://pays2s.intelligent-earnings.com/6969jp/th/fail-registration");

    this.sourceList.push({"name":sourceName, "notes": notesList});
  }

  private loadPureTech(){
    let sourceName = "PureTech";
    let notesList = [];

    notesList.push("We receive mo&dn by callback url");
    notesList.push("MO Postback URL: http://pays2s.intelligent-earnings.com/pure_tech/mo");
    notesList.push("DN Postback URL: http://pays2s.intelligent-earnings.com/pure_tech/dn");

    this.sourceList.push({"name":sourceName, "notes": notesList});
  }

  private loadQatarOoredoo(){
    let sourceName = "Qatar Ooredoo";
    let notesList = [];

    notesList.push("We will manage all subscribe/unsubscribe flow and maintain the subscriber data.");
    notesList.push("There is a fallback charging logic");
    notesList.push("There is 2 subscription method: SMS & DCB");
    notesList.push("MO Callback URL: http://pays2s.intelligent-earnings.com/mt2/Ooredoo/qatar/mo");
    notesList.push("Bill Result Callback URL: http://pays2s.intelligent-earnings.com/mt2/Ooredoo/qatar/bill-status");

    this.sourceList.push({"name":sourceName, "notes": notesList});
  }

  private loadUaEtisalat(){
    let sourceName = "UAE Etisalat";
    let notesList = [];

    notesList.push("We control the dcb subscription flow.");
    notesList.push("The renewal mechanism is generate by operator.");
    notesList.push("DN Callback URL : http://pays2s.intelligent-earnings.com/mt2/uae/est/dn");

    this.sourceList.push({"name":sourceName, "notes": notesList});
  }

  private loadUaDU(){
    let sourceName = "UAE DU";
    let notesList = [];

    notesList.push("The subscription flow is controlled by partner");
    notesList.push("The renewal mechanism is controlled by operator.");
    notesList.push("DN Callback URL: http://pays2s.intelligent-earnings.com/mt2/uae/du/dn");

    this.sourceList.push({"name":sourceName, "notes": notesList});
  }

  private loadAbis(){
    let sourceName = "ABIS";
    let notesList = [];

    notesList.push("We need to generate token to complete subscription action by calling their api.");
    notesList.push("We receive mo&dr notification and maintain the subscriber to do renewal action");
    notesList.push("MO Callback URL: http://pays2s.intelligent-earnings.com/abis/mo");
    notesList.push("DR Callback URL: http://pays2s.intelligent-earnings.com/abis/dr");

    this.sourceList.push({"name":sourceName, "notes": notesList});
  }

  private loadIonnexMT(){
    let sourceName = "Ionnex_MT (Malaysia & Renewal by us)";
    let notesList = [];

    notesList.push("It's for Malaysia keyword");
    notesList.push("Except Celcom operator at present");
    notesList.push("We receive mo&dr notification and maintain the subscriber data to do renewal action.");
    notesList.push("MO Callback URL: http://pays2s.intelligent-earnings.com/ionnex2/my/mo");
    notesList.push("DR Callback URL: http://pays2s.intelligent-earnings.com/ionnex2/my/dr");

    this.sourceList.push({"name":sourceName, "notes": notesList});
  }

  private loadQrSolutions(){
    let sourceName = "QR Solutions";
    let notesList = [];

    notesList.push("It's for malaysia keyword");
    notesList.push("Except Celcom operator at present");
    notesList.push("We receive mo&dr notification and maintain the subscriber data to do renewal action.");
    notesList.push("MO Callback URL: http://pays2s.intelligent-earnings.com/qrs/my/mo");
    notesList.push("DR Callback URL: http://pays2s.intelligent-earnings.com/qrs/my/dr");

    this.sourceList.push({"name":sourceName, "notes": notesList});
  }

  private loadTemplate(){
    let sourceName = "";
    let notesList = [];

    notesList.push("");

    this.sourceList.push({"name":sourceName, "notes": notesList});
  }

}
